import React, { useEffect } from 'react';
import { CustomDelete, MinLoader } from 'components';

export const UnsavedChangesPrompt = ({ open, canSave, saving, onSave, onDiscard, onCancel }) => {
    useEffect(() => {
        if (!open) return undefined;
        const handleKey = (event) => {
            if (event.key === 'Escape' && !saving) onCancel();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [open, saving, onCancel]);

    if (!open) return null;

    const handleCancel = () => {
        if (!saving) onCancel();
    };

    return (
        <div className="sdoc-unsaved-root" role="alertdialog" aria-modal="true">
            <div className="sdoc-unsaved-backdrop" onClick={handleCancel} />
            <div className="sdoc-unsaved-dialog">
                <CustomDelete
                    info="Unsaved Changes"
                    text="You have unsaved changes. Are you sure you want to leave this page?"
                    innerText="Discard Changes"
                    color="blue"
                    handleDel={onDiscard}
                    handleClose={handleCancel}
                    disableAction={saving}
                    noClose={true}
                    // body={
                    //     canSave && (
                    //         <button type="button" className="confirm-btn-light sdoc-unsaved-save" onClick={onSave} disabled={saving}>
                    //             {saving ? <MinLoader margin={'0'} color={'#0B5DCF'} position={'relative'} /> : 'Save Changes'}
                    //         </button>
                    //     )
                    // }
                />
            </div>
        </div>
    );
};
